<template>
  <div>
    <!--<div id="welcome" v-if="welcome">-->
    <!--</div>-->
    <!--<Login v-if="showLogin"/>-->
    <div id="app" v-if="showApp">
      <!-- <transition :name="transitionName">
        <navigation> -->
          <!-- <router-view class="child-view" v-if="showMain" ></router-view> -->
            <keep-alive>
                <router-view class="child-view" v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view  class="child-view" v-if="!$route.meta.keepAlive" />

        <!-- </navigation>
      </transition> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import server from './server/index.js'
//    import Login from './modules/Login.vue'
export default {
  name: "App",
  components: {
    //            Login,
  },
  data: function() {
    return {
      transitionName: "none",
      welcome: false,
      showApp:false,
    };
  },
  created: function() {
    // 获取当日访问url地址
    this.findTodayUrl()

  },
  // beforeDestroyed()
  // {
  //   sessionStorage.removeItem("routeLanguage")
  // },
  watch: {
    $route(to, from) {
      console.log(to, from)
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // 如果是ios 需要告诉ios 是否显示返回按钮
      // 一级页面 getBackStatus 传递true
      // 一级以后（二三四...） getBackStatus 传递false
      // console.log("to",to)
      // console.log("from",from)
      if(to.path != "/" && to.path != "/en" )
      {
        // 海外版app 安卓增加返回按钮
        if(isAndroid){
          try{
            window.Android.getBackStatus(true);
          }
          catch(err){
            // console.log("errerrerrerrerr",err)
          }
        }
        // 海外版app ios增加返回按钮
        if(isiOS){
          try{
           window.webkit.messageHandlers.getBackStatus.postMessage(true);
          }
          catch(err){
            // console.log("errerrerrerrerr",err)
          }
        }
      }
      else
      {
        // 海外版app 安卓取消返回按钮
        if(isAndroid){
          //  console.log("appAndroid",false,false,false)
           try{
            window.Android.getBackStatus(false);
          }
          catch(err){
            // console.log("errerrerrerrerr",err)
          }
        }
        // 海外版app ios取消返回按钮
        if(isiOS){
          // console.log("appIOS",false,false,false)
          try{
           window.webkit.messageHandlers.getBackStatus.postMessage(false);
          }
          catch(err){
            // console.log("errerrerrerrerr",err)
          }
        }
      }
      if (from.path == "/" && to.path == "/")
      {
        this.transitionName = "none";
        return;
      }
      let fromDepth = from.path.split("/").length;
      let toDepth = to.path.split("/").length;
      if (fromDepth == toDepth) {
        this.transitionName =
          to.path.length > from.path.length ? "slide-right" : "slide-left";
      } else {
        this.transitionName =
          toDepth > fromDepth ? "slide-right" : "slide-left";
      }
    }
  },
  methods:{
    //获取当日访问url地址
    findTodayUrl()
    {
      server.findTodayUrl({})
      .then((res) => {
        if (res.data.code == 100 && res.data.data && res.data.data.url)
        {
          let nowUrl = window.location.origin+"/";
          if(nowUrl == res.data.data.url)
          {
            this.todayUrl = res.data.data.url;
            // 跳转逻辑
            // 后台返回 一个今天可以访问的地址 比如aaa.com
            // 然后判断网址（location.host） 是否等于aaa.com  等于即可访问，否则直接跳转百度
            // 显示欢迎页面2s
            if (this.welcome) {
              setTimeout(() => {
                this.welcome = false;
              }, 2000);
            }
            this.showApp = true;
            // 根据ip 判断是否加载YouTube
            this.loadYoutubeJs();
          }
          else
          {
            window.location.href = "https://www.baidu.com";
          }
        }
        else
        {
          window.location.href = "https://www.baidu.com";
        }
      })
      .catch((error) => {
        window.location.href = "https://www.baidu.com";
      })

    },
    loadYoutubeJs()
    {
      // window.localIP = "111.200.218.56" ;//测试国内ip
      // console.log("appCreated iframe",window.localIP)
      // if (window.localIP)
      // {
        $.ajax({
            type: "GET",
            url: 'https://aggshop.juhaowu.cn/intcoreapi/base/ipFrom',
            contentType: "application/json;charset=utf-8",
            data: {},
            headers:{'language':'chinese'},
            success: function (res) {
                if (res.data ) {
                    if (res.data.isChina) {

                    } else {
                    let tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    let firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    }
                }
            },
            fail:function (error) {

            },
        })
        // server.chinaIpJudge2({})
        // .then((res) => {
        //   // console.log(res)
        //   if (res.data && res.data.data) {
        //     if (res.data.data.isChina) {

        //     } else {
        //       let tag = document.createElement('script');
        //       tag.src = "https://www.youtube.com/iframe_api";
        //       let firstScriptTag = document.getElementsByTagName('script')[0];
        //       firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        //     }
        //   }
        // })
        // .catch((error) => {

        // });
      // }
    },
  }
};
</script>

<style>
* {
  -webkit-tap-highlight-color: transparent;
}
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: "lucida grande", "lucida sans unicode", lucida, helvetica,
    "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  font-size: 0.3rem;
}

#welcome {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: cornflowerblue;
}

.child-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  transition: all 0.6s cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(-80px, 0);
  transform: translate(-80px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
body {
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue